//import required libraries
import './cookies';
import './shared';
const $ = require('jquery');
const validation = require('jquery-validation-unobtrusive');


//setup event listeners and initialize function boxes
$(document).ready(function() {
    validation.parse($('#demo-form'));

    //set initial function box in carousel
    initCarousel();
    //change status of active function box in carousel
    $('#functions-carousel').on('slid.bs.carousel', function(slideEvent) {
        setActiveCarousel(slideEvent);
        let previews = $('.preview');
        previews[slideEvent.to].classList.remove("sliding");
        if (slideEvent.to < slideEvent.from || (slideEvent.to == 5 && slideEvent.from == 0)) {
            previews[slideEvent.from].classList.remove("active-preview");
            previews[slideEvent.from].classList.add("sliding");
            previews[slideEvent.to].classList.add("active-preview");
        }
    });

    //change carousel image and preview box
    $('#functions-carousel').on('slide.bs.carousel', function(slideEvent) {
        var id = slideEvent.relatedTarget.id - 1;
        let previews = $('.preview');

        if (slideEvent.to > slideEvent.from || (slideEvent.to == 0 && slideEvent.from == 5)) {
            previews[slideEvent.from].classList.remove("active-preview");
            previews[slideEvent.from].classList.add("sliding");
            previews[slideEvent.to].classList.add("active-preview");
        }

        setInactiveCarousel(slideEvent);

        let smallImagesList = $('.sm-images .image-holder');
        id %= smallImagesList.length;
        for (let index = 0; index < smallImagesList.length; index++) {
            if (index == id) {
                smallImagesList[index].classList.remove('d-none');
                smallImagesList[index].classList.add('d-block');
            }
            if (index == slideEvent.from) {
                if (smallImagesList[index].classList.contains('d-none')) {
                    continue;
                }
                smallImagesList[index].classList.add('d-none');
                smallImagesList[index].classList.remove('d-block');
            }

        }
    });

    function scrollToSettings(location) {
        return /cookie-settings/gi.test(location);
    }

    if (scrollToSettings(window.location.href)) {
        setTimeout(() => {
            $('.cookie-settings')[0].scrollIntoView();
        }, 10);
    }

    //change status of last/currently visited function box
    var largeFunctionsList = document.getElementsByClassName('functions');
    for (var i = 0; i < largeFunctionsList.length; i++)
        largeFunctionsList[i].addEventListener('mouseenter', setActive, false);
    
    $('#demo-form').on('submit', validateInput);
    $('#close-msg').on('click', confirmClose);
    $('#close-err-msg').on('click', errorClose);
});


//initialize carousel
function initCarousel() {
    let activeElement = $('.carousel-item.active');
    if (activeElement.length) {
        let innerDivActive = activeElement[0].childNodes;
        //let innerDivActive = outerDivActive[1].childNodes;
        let parallelogram = document.createElement("div");
        parallelogram.classList.add("parallelogram");
        innerDivActive[1].appendChild(parallelogram);
    }
}

//set normal status to inactive carousel function box
function setInactiveCarousel(slideEvent) {
    let elements = $('.carousel-item');
    let previousActiveElement = elements[slideEvent.from];
    let previousActiveInnerDiv = previousActiveElement.childNodes;
    if (previousActiveInnerDiv[1].childNodes[3] != null) previousActiveInnerDiv[1].childNodes[3].remove();

}


//set active status to inactive carousel function box
function setActiveCarousel(slideEvent) {
    let newActiveInnerDiv = slideEvent.relatedTarget.childNodes;
    let parallelogram = document.createElement("div");
    parallelogram.classList.add("parallelogram");
    newActiveInnerDiv[1].appendChild(parallelogram);
}

let lastIndex = "1";
let imagesList = document.getElementsByClassName("image-holder");

function setActive(event) {
    let target = event.target ? event.target : event.srcElement;
    deselect(lastIndex);
    let element = target.children;
    let parallelogram = document.createElement("div");
    element[0].classList.add("fbactive");
    parallelogram.classList.add("parallelogram");
    element[0].appendChild(parallelogram);
    imagesList[parseInt(target.id) - 1].classList.remove("d-none");
    imagesList[parseInt(target.id) - 1].classList.add("d-block");
    lastIndex = target.id;
}

function setInActive(target, id) {
    let element = target.children;
    element[0].classList.remove("fbactive");
    element[0].children[1].remove();
    imagesList[parseInt(id) - 1].classList.remove("d-block");
    imagesList[parseInt(id) - 1].classList.add("d-none");
}

function deselect(id) {
    let target = document.getElementById(id);
    setInActive(target, id);
}

//functions to handle form inputs
function validateInput() {
    if($('#demo-form').valid()){
        submit()
            .then(() => {
                formSubmissionSuccess();
            }).catch(() => {
                formSubmissionFailure();
            });
    }
}

function formSubmissionSuccess() {
    let message = document.getElementById("confirmation-message");
    message.classList.add("display-mess");
    let button = document.getElementById("btn-val");
    button.classList.remove("d-none");
    button.classList.add("d-block");
    let loader = document.getElementsByClassName("lds-ring")[0];
    loader.classList.add("d-none");
    document.getElementsByTagName("form")[0].reset();
}

function formSubmissionFailure() {
    let message = document.getElementById("error-message");
    message.classList.add("display-mess");
    let button = document.getElementById("btn-val");
    button.classList.remove("d-none");
    button.classList.add("d-block");
    let loader = document.getElementsByClassName("lds-ring")[0];
    loader.classList.add("d-none");
}

function confirmClose() {
    let confirmationMessage = document.getElementById("confirmation-message");
    confirmationMessage.classList.remove("display-mess");
}

function errorClose() {
    let confirmationMessage = document.getElementById("error-message");
    confirmationMessage.classList.remove("display-mess");
}

function submit() {
    let button = document.getElementById("btn-val");
    button.classList.remove("d-block");
    button.classList.add("d-none");
    let loader = document.getElementsByClassName("lds-ring")[0];
    loader.classList.remove("d-none");

    return fetch('/Home/SendEmail', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: $("#demo-form").serialize()
    }).then(response => {
        if (!response.ok) {
            throw Error(response.statusText);
        }
    });
}